import { createActions, createReducer } from 'reduxsauce'

const listaPagos = [
    { value: '', label: 'Todas' },
    { value: 'S', label: 'Sim' },
    { value: 'N', label: 'Não' },
]

/**
 * Action types & creators
 */

const categoriasProcesso = [
    { value: '', label: 'Nenhum' },
    { value: '1', label: 'Cessão' },
    { value: '2', label: 'Compras' },
    { value: '3', label: 'Informática (TIC)' },
    { value: '4', label: 'Internacional' },
    { value: '5', label: 'Locação Imóveis' },
    { value: '6', label: 'Mão de Obra' },
    { value: '7', label: 'Obras' },
    { value: '8', label: 'Serviços' },
    { value: '9', label: 'Serviços de Engenharia' },
    { value: '10', label: 'Serviços de Saúde' },
    { value: '11', label: 'Alienação de bens móveis/imóveis' },
]

export const { Types, Creators } = createActions({
    setAdministracaoConsultaEmpenhoCredor: ['administracao'],
    setExercicioEmpenhoInicialConsultaEmpenhoCredor: ['exercicioEmpenhoInicial'],
    setExercicioEmpenhoFinalConsultaEmpenhoCredor: ['exercicioEmpenhoFinal'],
    setNumeroEmpenhoInicialConsultaEmpenhoCredor: ['numeroEmpenhoInicial'],
    setNumeroEmpenhoFinalConsultaEmpenhoCredor: ['numeroEmpenhoFinal'],
    setDataEmpenhoInicialConsultaEmpenhoCredor: ['dataEmpenhoInicial'],
    setDataEmpenhoFinalConsultaEmpenhoCredor: ['dataEmpenhoFinal'],
    setDataVencimentoInicialConsultaEmpenhoCredor: ['dataVencimentoInicial'],
    setDataVencimentoFinalConsultaEmpenhoCredor: ['dataVencimentoFinal'],
    setPagosConsultaEmpenhoCredor: ['pagos'],
    setRecursoConsultaEmpenhoCredor: ['recurso'],
    setDestinacaoConsultaEmpenhoCredor: ['destinacao'],
    setNomeCredorConsultaEmpenhoCredor: ['nomeCredor'],
    setCnpjConsultaEmpenhoCredor: ['cnpj'],
    setCpfConsultaEmpenhoCredor: ['cpf'],
    setDocumentoConsultaEmpenhoCredor: ['documento'],
    setExercicioProtocoloInicialConsultaEmpenhoCredor: ['exercicioProtocoloInicial'],
    setExercicioProtocoloFinalConsultaEmpenhoCredor: ['exercicioProtocoloFinal'],
    setNumeroProtocoloInicialConsultaEmpenhoCredor: ['numeroProtocoloInicial'],
    setNumeroProtocoloFinalConsultaEmpenhoCredor: ['numeroProtocoloFinal'],
    setProcessoReferenciaConsultaEmpenhoCredor: ['processoReferencia'],
    setCategoriaProcessoConsultaEmpenhoCredor: ['categoriaProcesso'],
    limpaFiltroConsultaEmpenhoCredor: [],
    receberFiltroConsultaEmpenhoCredor: ['filtroRecebido'],
})

const INITIAL_STATE = {
    administracao: [],
    exercicioEmpenhoInicial: '',
    exercicioEmpenhoFinal: '',
    numeroEmpenhoInicial: '',
    numeroEmpenhoFinal: '',
    dataEmpenhoInicial: '',
    dataEmpenhoFinal: '',
    dataVencimentoInicial: '',
    dataVencimentoFinal: '',
    pagos: { value: listaPagos[0].value, label: listaPagos[0].label },
    recurso: [],
    destinacao: [],
    nomeCredor: '',
    cnpj: '',
    cpf: '',
    documento: '',
    exercicioProtocoloInicial: '',
    exercicioProtocoloFinal: '',
    numeroProtocoloInicial: '',
    numeroProtocoloFinal: '',
    processoReferencia: '',
    categoriaProcesso: { value: categoriasProcesso[0].value, label: categoriasProcesso[0].label },
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}
const setExercicioEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioEmpenhoInicial: action.exercicioEmpenhoInicial }
}
const setExercicioEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioEmpenhoFinal: action.exercicioEmpenhoFinal }
}
const setNumeroEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroEmpenhoInicial: action.numeroEmpenhoInicial }
}
const setNumeroEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroEmpenhoFinal: action.numeroEmpenhoFinal }
}
const setDataEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoInicial: action.dataEmpenhoInicial }
}
const setDataEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoFinal: action.dataEmpenhoFinal }
}
const setDataVencimentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoInicial: action.dataVencimentoInicial }
}
const setDataVencimentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoFinal: action.dataVencimentoFinal }
}
const setPagos = (state = INITIAL_STATE, action) => {
    return { ...state, pagos: action.pagos }
}
const setRecurso = (state = INITIAL_STATE, action) => {
    return { ...state, recurso: action.recurso }
}
const setDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, destinacao: action.destinacao }
}
const setNomeCredor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeCredor: action.nomeCredor }
}
const setCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: action.cnpj }
}
const setCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: action.cpf }
}
const setDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, documento: action.documento }
}

const setExercicioProtocoloInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioProtocoloInicial: action.exercicioProtocoloInicial }
}
const setExercicioProtocoloFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioProtocoloFinal: action.exercicioProtocoloFinal }
}
const setNumeroProtocoloInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroProtocoloInicial: action.numeroProtocoloInicial }
}
const setNumeroProtocoloFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroProtocoloFinal: action.numeroProtocoloFinal }
}

const setProcessoReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, processoReferencia: action.processoReferencia }
}

const setCategoriaProcesso = (state = INITIAL_STATE, action) => {
    return { ...state, categoriaProcesso: action.categoriaProcesso }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACAO_CONSULTA_EMPENHO_CREDOR]: setAdministracao,
    [Types.SET_EXERCICIO_EMPENHO_INICIAL_CONSULTA_EMPENHO_CREDOR]: setExercicioEmpenhoInicial,
    [Types.SET_EXERCICIO_EMPENHO_FINAL_CONSULTA_EMPENHO_CREDOR]: setExercicioEmpenhoFinal,
    [Types.SET_NUMERO_EMPENHO_INICIAL_CONSULTA_EMPENHO_CREDOR]: setNumeroEmpenhoInicial,
    [Types.SET_NUMERO_EMPENHO_FINAL_CONSULTA_EMPENHO_CREDOR]: setNumeroEmpenhoFinal,
    [Types.SET_DATA_EMPENHO_INICIAL_CONSULTA_EMPENHO_CREDOR]: setDataEmpenhoInicial,
    [Types.SET_DATA_EMPENHO_FINAL_CONSULTA_EMPENHO_CREDOR]: setDataEmpenhoFinal,
    [Types.SET_DATA_VENCIMENTO_INICIAL_CONSULTA_EMPENHO_CREDOR]: setDataVencimentoInicial,
    [Types.SET_DATA_VENCIMENTO_FINAL_CONSULTA_EMPENHO_CREDOR]: setDataVencimentoFinal,
    [Types.SET_PAGOS_CONSULTA_EMPENHO_CREDOR]: setPagos,
    [Types.SET_RECURSO_CONSULTA_EMPENHO_CREDOR]: setRecurso,
    [Types.SET_DESTINACAO_CONSULTA_EMPENHO_CREDOR]: setDestinacao,
    [Types.SET_NOME_CREDOR_CONSULTA_EMPENHO_CREDOR]: setNomeCredor,
    [Types.SET_CNPJ_CONSULTA_EMPENHO_CREDOR]: setCnpj,
    [Types.SET_CPF_CONSULTA_EMPENHO_CREDOR]: setCpf,
    [Types.SET_DOCUMENTO_CONSULTA_EMPENHO_CREDOR]: setDocumento,
    [Types.SET_EXERCICIO_PROTOCOLO_INICIAL_CONSULTA_EMPENHO_CREDOR]: setExercicioProtocoloInicial,
    [Types.SET_EXERCICIO_PROTOCOLO_FINAL_CONSULTA_EMPENHO_CREDOR]: setExercicioProtocoloFinal,
    [Types.SET_NUMERO_PROTOCOLO_INICIAL_CONSULTA_EMPENHO_CREDOR]: setNumeroProtocoloInicial,
    [Types.SET_NUMERO_PROTOCOLO_FINAL_CONSULTA_EMPENHO_CREDOR]: setNumeroProtocoloFinal,
    [Types.SET_PROCESSO_REFERENCIA_CONSULTA_EMPENHO_CREDOR]: setProcessoReferencia,
    [Types.SET_CATEGORIA_PROCESSO_CONSULTA_EMPENHO_CREDOR]: setCategoriaProcesso,
    [Types.LIMPA_FILTRO_CONSULTA_EMPENHO_CREDOR]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_EMPENHO_CREDOR]: receberFiltro,
})
